import {Component, OnInit, ViewChild} from '@angular/core';
import {PageListConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {SettingsEventActionService} from "./settings-eventaction.service";
import {DtoEventAction} from "../../shared/models/DtoEventAction";
import {ActionType} from "../../shared/enums/actionType";
import {EventActionComponent} from "./eventaction.component";
import {DialogService} from "@progress/kendo-angular-dialog";
import {DtoDeleteResult} from "../../shared/models/DtoDeleteResult";
import {SharedService} from "../../shared/shared.service";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";

@Component({
    selector: 'app-settings-eventaction-perm',
    template: require('./settings-eventaction-perm.component.html'),
    styles: [require('./settings-eventaction-perm.component.css')]
})

@AutoUnsubscribe()
export class SettingsEventActionPermComponent implements OnInit {
    @ViewChild('gridProduct', {static: false}) gridProduct: DynamicGridComponent;
    @ViewChild('gridFixation', {static: false}) gridFixation: DynamicGridComponent;
    @ViewChild('gridPreTreatment', {static: false}) gridPreTreatment: DynamicGridComponent;
    @ViewChild('gridPostTreatment', {static: false}) gridPostTreatment: DynamicGridComponent;
    @ViewChild('gridWrapperChoice', {static: false}) gridWrapperChoice: DynamicGridComponent;
    @ViewChild('gridWrapperSystem', {static: false}) gridWrapperSystem: DynamicGridComponent;
    @ViewChild('gridWrapperColor', {static: false}) gridWrapperColor: DynamicGridComponent;
    @ViewChild('gridWrapperPerm', {static: false}) gridWrapperPerm: DynamicGridComponent;

    config: PageListConfig;
    productData: DtoEventAction[];
    fixationData: DtoEventAction[];
    preTreatmentData: DtoEventAction[];
    postTreatmentData: DtoEventAction[];
    wrapperChoiceData: DtoEventAction[];
    wrapperSystemData: DtoEventAction[];
    wrapperColorData: DtoEventAction[];
    wrapperPermData: DtoEventAction[];


    constructor(private breadcrumService: BreadcrumService,
                private ds: SettingsEventActionService,
                private dialogService: DialogService,
                private ss: SharedService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'instellingen', isLastStep: false },
            { text: 'permanentkaart instellingen', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.config = {
            rowKey: 'id',
            columnDefinition: [
                {
                    key: 'actionIndex',
                    label: 'Volgnummer',
                    type: 'number',
                    width: '140px'
                },
                {
                    key: 'description',
                    label: 'Omschrijving',
                    type: 'string',
                    width: '*'
                }
            ],
            pageHeaderBarConfig: {
                title: '',
                buttonDefinition: [
                    {
                        description: 'TOEVOEGEN',
                        clickEventType: 'create',
                        isSmall: false
                    },
                    {
                        description: 'WIJZIGEN',
                        clickEventType: 'edit',
                        isSmall: false
                    },
                    {
                        description: 'VERWIJDEREN',
                        clickEventType: 'delete',
                        isSmall: false
                    }
                ]
            }
        };
    }

    ngAfterViewInit() {
        this.loadProducts(false);
    }

    tabSelected(e) {
        if (e.index == 0) {
            this.loadProducts(false);
        } else if (e.index == 1) {
            this.loadFixations(false);
        } else if (e.index == 2) {
            this.loadPreTreatment(false);
        } else if (e.index == 3) {
            this.loadPostTreatment(false);
        } else if (e.index == 4) {
            this.loadWrapperChoice(false);
        } else if (e.index == 5) {
            this.loadWrapperSystem(false);
        } else if (e.index == 6) {
            this.loadWrapperColor(false);
        } else if (e.index == 7) {
            this.loadWrapperPerm(false);
        }
    }

    showEventActionEditWindow(id: number, typeId: number, header: string, subheader: string) {
        const dialogRef = this.dialogService.open({
            content: EventActionComponent
        });

        const dialogContent: EventActionComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.typeId = typeId;
        dialogContent.header = header;
        dialogContent.subheader = subheader;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    if (typeId == ActionType.PERMPRODUCT)
                        this.loadProducts(true);
                    else if (typeId == ActionType.FIXATION)
                        this.loadFixations(true);
                    else if (typeId == ActionType.PERMPRETREATMENT)
                        this.loadPreTreatment(true);
                    else if (typeId == ActionType.PERMPOSTTREATMENT)
                        this.loadPostTreatment(true);
                    else if (typeId == ActionType.PERMWRAPPERCHOICE)
                        this.loadWrapperChoice(true);
                    else if (typeId == ActionType.PERMWRAPPERSYSTEM)
                        this.loadWrapperSystem(true);
                    else if (typeId == ActionType.PERMWRAPPERCOLOR)
                        this.loadWrapperColor(true);
                    else if (typeId == ActionType.PERMWRAPPER)
                        this.loadWrapperPerm(true);
                }
            });
    }

    getSelectedId(type: number): number {
        if (type == ActionType.PERMPRODUCT) {
            return this.gridProduct.getSelectedId();
        } else if (type == ActionType.FIXATION) {
            return this.gridFixation.getSelectedId();
        } else if (type == ActionType.PERMPRETREATMENT) {
            return this.gridPreTreatment.getSelectedId();
        } else if (type == ActionType.PERMPOSTTREATMENT) {
            return this.gridPostTreatment.getSelectedId();
        } else if (type == ActionType.PERMWRAPPERCHOICE) {
            return this.gridWrapperChoice.getSelectedId();
        } else if (type == ActionType.PERMWRAPPERSYSTEM) {
            return this.gridWrapperSystem.getSelectedId();
        } else if (type == ActionType.PERMWRAPPERCOLOR) {
            return this.gridWrapperColor.getSelectedId();
        } else if (type == ActionType.PERMWRAPPER) {
            return this.gridWrapperPerm.getSelectedId();
        }

        return 0;
    }

    // PRODUCT
    loadProducts(reload: boolean) {
        if (reload || !this.productData) {
            this.ds.getEventActionsForTypes([ActionType.PERMPRODUCT]).subscribe((res: DtoEventAction[]) => {
                this.productData = res;
                this.gridProduct.showData(this.productData);
            });
        }
    }

    phbProductBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.PERMPRODUCT, 'PERMANENTKAART', 'PRODUCT');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.PERMPRODUCT) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMPRODUCT), ActionType.PERMPRODUCT, 'PERMANENTKAART', 'PRODUCT');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.PERMPRODUCT) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.PERMPRODUCT))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadProducts(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridProductRowDoubleClicked(event) {
        if (this.getSelectedId(ActionType.PERMPRODUCT) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMPRODUCT), ActionType.PERMPRODUCT, 'PERMANENTKAART', 'PRODUCT');
        }
    }

    // FIXATION
    loadFixations(reload: boolean) {
        if (reload || !this.fixationData) {
            this.ds.getEventActionsForTypes([ActionType.FIXATION]).subscribe((res: DtoEventAction[]) => {
                this.fixationData = res;
                this.gridFixation.showData(this.fixationData);
            });
        }
    }

    phbFixationBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.FIXATION, 'PERMANENTKAART', 'FIXATIE');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.FIXATION) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.FIXATION), ActionType.FIXATION, 'PERMANENTKAART', 'FIXATIE');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.FIXATION) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.FIXATION))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadFixations(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridFixationRowDoubleClicked(event) {
        if (this.getSelectedId(ActionType.FIXATION) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.FIXATION), ActionType.FIXATION, 'PERMANENTKAART', 'FIXATIE');
        }
    }

    // PRETREATMENT
    loadPreTreatment(reload: boolean) {
        if (reload || !this.preTreatmentData) {
            this.ds.getEventActionsForTypes([ActionType.PERMPRETREATMENT]).subscribe((res: DtoEventAction[]) => {
                this.preTreatmentData = res;
                this.gridPreTreatment.showData(this.preTreatmentData);
            });
        }
    }

    phbPreTreatmentBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.PERMPRETREATMENT, 'PERMANENTKAART', 'VOORBEHANDELING');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.PERMPRETREATMENT) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMPRETREATMENT), ActionType.PERMPRETREATMENT, 'PERMANENTKAART', 'VOORBEHANDELING');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.PERMPRETREATMENT) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.PERMPRETREATMENT))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadPreTreatment(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridPreTreatmentRowDoubleClicked(event) {
        if (this.getSelectedId(ActionType.PERMPRETREATMENT) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMPRETREATMENT), ActionType.PERMPRETREATMENT, 'PERMANENTKAART', 'VOORBEHANDELING');
        }
    }

    // POSTTREATMENT
    loadPostTreatment(reload: boolean) {
        if (reload || !this.postTreatmentData) {
            this.ds.getEventActionsForTypes([ActionType.PERMPOSTTREATMENT]).subscribe((res: DtoEventAction[]) => {
                this.postTreatmentData = res;
                this.gridPostTreatment.showData(this.postTreatmentData);
            });
        }
    }

    phbPostTreatmentBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.PERMPOSTTREATMENT, 'PERMANENTKAART', 'NABEHANDELING');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.PERMPOSTTREATMENT) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMPOSTTREATMENT), ActionType.PERMPOSTTREATMENT, 'PERMANENTKAART', 'NABEHANDELING');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.PERMPOSTTREATMENT) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.PERMPOSTTREATMENT))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadPostTreatment(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridPostTreatmentRowDoubleClicked(event) {
        if (this.getSelectedId(ActionType.PERMPOSTTREATMENT) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMPOSTTREATMENT), ActionType.PERMPOSTTREATMENT, 'PERMANENTKAART', 'NABEHANDELING');
        }
    }

    // WRAPPERCHOICE
    loadWrapperChoice(reload: boolean) {
        if (reload || !this.wrapperChoiceData) {
            this.ds.getEventActionsForTypes([ActionType.PERMWRAPPERCHOICE]).subscribe((res: DtoEventAction[]) => {
                this.wrapperChoiceData = res;
                this.gridWrapperChoice.showData(this.wrapperChoiceData);
            });
        }
    }

    phbWrapperChoiceBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.PERMWRAPPERCHOICE, 'PERMANENTKAART', 'WIKKELKEUZE');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.PERMWRAPPERCHOICE) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMWRAPPERCHOICE), ActionType.PERMWRAPPERCHOICE, 'PERMANENTKAART', 'WIKKELKEUZE');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.PERMWRAPPERCHOICE) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.PERMWRAPPERCHOICE))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadWrapperChoice(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridWrapperChoiceRowDoubleClicked(event) {
        if (this.getSelectedId(ActionType.PERMWRAPPERCHOICE) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMWRAPPERCHOICE), ActionType.PERMWRAPPERCHOICE, 'PERMANENTKAART', 'WIKKELKEUZE');
        }
    }

    // WRAPPERSYSTEM
    loadWrapperSystem(reload: boolean) {
        if (reload || !this.wrapperSystemData) {
            this.ds.getEventActionsForTypes([ActionType.PERMWRAPPERSYSTEM]).subscribe((res: DtoEventAction[]) => {
                this.wrapperSystemData = res;
                this.gridWrapperSystem.showData(this.wrapperSystemData);
            });
        }
    }

    phbWrapperSystemBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.PERMWRAPPERSYSTEM, 'PERMANENTKAART', 'WIKKELSYSTEEM');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.PERMWRAPPERSYSTEM) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMWRAPPERSYSTEM), ActionType.PERMWRAPPERSYSTEM, 'PERMANENTKAART', 'WIKKELSYSTEEM');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.PERMWRAPPERSYSTEM) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.PERMWRAPPERSYSTEM))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadWrapperSystem(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridWrapperSystemRowDoubleClicked(event) {
        if (this.getSelectedId(ActionType.PERMWRAPPERSYSTEM) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMWRAPPERSYSTEM), ActionType.PERMWRAPPERSYSTEM, 'PERMANENTKAART', 'WIKKELSYSTEEM');
        }
    }

    // WRAPPERCOLOR
    loadWrapperColor(reload: boolean) {
        if (reload || !this.wrapperColorData) {
            this.ds.getEventActionsForTypes([ActionType.PERMWRAPPERCOLOR]).subscribe((res: DtoEventAction[]) => {
                this.wrapperColorData = res;
                this.gridWrapperColor.showData(this.wrapperColorData);
            });
        }
    }

    phbWrapperColorBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.PERMWRAPPERCOLOR, 'PERMANENTKAART', 'WIKKELKLEUR');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.PERMWRAPPERCOLOR) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMWRAPPERCOLOR), ActionType.PERMWRAPPERCOLOR, 'PERMANENTKAART', 'WIKKELKLEUR');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.PERMWRAPPERCOLOR) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.PERMWRAPPERCOLOR))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadWrapperColor(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridWrapperColorRowDoubleClicked(event) {
        if (this.getSelectedId(ActionType.PERMWRAPPERCOLOR) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMWRAPPERCOLOR), ActionType.PERMWRAPPERCOLOR, 'PERMANENTKAART', 'WIKKELKLEUR');
        }
    }

    // WRAPPERPERM
    loadWrapperPerm(reload: boolean) {
        if (reload || !this.wrapperPermData) {
            this.ds.getEventActionsForTypes([ActionType.PERMWRAPPER]).subscribe((res: DtoEventAction[]) => {
                this.wrapperPermData = res;
                this.gridWrapperPerm.showData(this.wrapperPermData);
            });
        }
    }

    phbWrapperPermBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.PERMWRAPPER, 'PERMANENTKAART', 'PERMANENTWIKKEL');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.PERMWRAPPER) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMWRAPPER), ActionType.PERMWRAPPER, 'PERMANENTKAART', 'PERMANENTWIKKEL');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.PERMWRAPPER) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.PERMWRAPPER))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadWrapperPerm(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridWrapperPermRowDoubleClicked(event) {
        if (this.getSelectedId(ActionType.PERMWRAPPER) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.PERMWRAPPER), ActionType.PERMWRAPPER, 'PERMANENTKAART', 'PERMANENTWIKKEL');
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-eventaction/settings-eventaction-perm.component.ts